import { generateIconNMRFile } from 'screening';
/**
 * Solvent select value meaning "unspecified". It is not a solventMapping key,
 * so the file falls back to DEFAULT_SOLVENT when it is selected.
 */
export const UNSPECIFIED_SOLVENT = '-';
/** Solvent used in the generated file when the selection is unspecified. */
export const DEFAULT_SOLVENT = 'defaultSolvent';
export function updateIconNMR(form) {
    const { experiments, iconNMROptions, solventMapping } = form;
    const { user, name, title, holder, solvent, deleteExistingHolder, autoSubmit, defaultParameters, } = iconNMROptions;
    let { firstExperimentNumber = 10 } = iconNMROptions;
    // `solvent` is the user-facing solventMapping key; the file uses the mapped
    // Bruker / IconNMR name. The unspecified "-" (and any unmapped value) falls
    // back to the default solvent.
    const mappedSolvent = solventMapping?.[solvent] ?? DEFAULT_SOLVENT;
    const data = {
        user,
        name,
        title,
        holder,
        experiments: [],
    };
    for (const experiment of experiments) {
        const parameters = [];
        for (const key in experiment.parameters) {
            parameters.push({ label: key, value: experiment.parameters[key] });
        }
        for (const key in defaultParameters) {
            parameters.push({ label: key, value: defaultParameters[key] });
        }
        data.experiments.push({
            experiment: experiment.name,
            experimentNumber: firstExperimentNumber++,
            solvent: mappedSolvent,
            parameters,
        });
    }
    form.iconNMR = generateIconNMRFile([data], {
        deleteExistingHolder,
        autoSubmit,
    });
}
//# sourceMappingURL=updateIconNMR.js.map